(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cero-global-collection"] && !Shopify.designMode) return;
  try {
    
  const sizeGroups = {
    top: ['TALLE-S', 'TALLE-M', 'TALLE-L', 'TALLE-XL', 'TALLE-XXL', 'TALLE-3XL', 'TALLE-4XL'],
    pants: ['TALLE-28', 'TALLE-30', 'TALLE-32', 'TALLE-34', 'TALLE-36', 'TALLE-38', 'TALLE-40', 'TALLE-42']
  };

  const tagHandle = (tag) => tag.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

  document.querySelectorAll('[data-size-filter-root]').forEach((root) => {
    let activeTags = [];
    try {
      activeTags = JSON.parse(root.dataset.currentTags || '[]') || [];
    } catch {
      activeTags = [];
    }

    root.querySelectorAll('[data-size-tag]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const tag = link.dataset.sizeTag;
        const group = link.dataset.sizeGroup;
        const wasActive = activeTags.includes(tag);
        activeTags = activeTags.filter((activeTag) => !sizeGroups[group].includes(activeTag));
        if (!wasActive) activeTags.push(tag);
        const suffix = activeTags.map(tagHandle).join('+');
        window.location.assign(root.dataset.collectionUrl + (suffix ? `/${suffix}` : ''));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cero-global-product"] && !Shopify.designMode) return;
  try {
    
  function updateOutfitTotal() {
    const price = Array.from(document.querySelectorAll('.outfit-variant')).reduce((total, select) => {
      const option = select.options[select.selectedIndex];
      return total + Number(option?.dataset.price || 0);
    }, 0);
    const output = document.getElementById('outfit-total-price');
    if (output) output.textContent = `US$ ${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price / 100)}`;
  }
  document.querySelectorAll('.outfit-variant').forEach((select) => select.addEventListener('change', updateOutfitTotal));
  updateOutfitTotal();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
